<template>
    <section class="Footer white-text">
        <div class="row">
            <div class="col s12 m12 center">
                <img src="/assets/images/logo/Logo-White.svg">
                <div class="social-menu">
                    <a :href="facebook" target="_blank"><font-awesome-icon :icon="fbIcon" /></a>
                    <a :href="youtube" target="_blank"><font-awesome-icon :icon="ytIcon" /></a>
                </div>
                <span class="copyright">Copyright House of Fire Christian Church &copy; {{ year }}. All Rights Reserved</span>
            </div>
        </div>
    </section>
</template>

<script>
    import ENV from '../constants/Environment.js';
    import { faFacebookSquare, faYoutubeSquare } from '@fortawesome/free-brands-svg-icons';

    export default {
        name: 'Footer',
        computed: {
            fbIcon () {
                return faFacebookSquare
            },
            ytIcon () {
                return faYoutubeSquare
            },  
        },
        data: function() {
            return {
                facebook: ENV.FACEBOOK_LINK,
                youtube: ENV.YOUTUBE_LINK,
                year: new Date().getFullYear()
            }
        }
    }
</script>

<style scoped>
    section {
        padding: 1.5rem 0 1rem 0;
        background: #222;
    }

    img {
        width: 100px;
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 1rem;
        /* float: left; */
    }

    .social-menu {
        margin: 5px 0 15px 0;
    }
    
    .social-menu a {
        color: #ffffff;
        font-size: 1.5rem;
    }

    .social-menu a:first-child {
        padding-right: 5px;
    } 

    .social-menu a:hover {
        color: #5b7c8a;
    }

    .copyright {
        font-size: .8rem;
    }
</style>